const BATCH_INDEX_DESCRIPTION_SEARCH = ' index [0-9]+ ';
let errorsTranslations: Record<string, string> | undefined = undefined;

export const setErrorsTranslations = (translations?: Record<string, string>) => {
	errorsTranslations = translations;
};

export type ErrorViolation = { propertyPath: string; message: string };

export const translateErrorText = (text: string) => errorsTranslations?.[text] || text;

export const getViolationsFromError = (err: any): ErrorViolation[] => {
	const responseData = (err?.connectorError ?? err)?.response?.data;
	return responseData?.constraintViolationList || responseData?.violations || [];
};

const toSentence = (text: string) => /[.!?]$/.test(text) ? text : `${text}.`;

export default function getTextAndTranslateFromError(err: any) {
	const requestError = err?.connectorError ?? err;
	const responseData = requestError?.response?.data;

	let errorCode: string = requestError?.request?.status
		? ` (code erreur ${requestError.request.status})`
		: '';
	let index: number | undefined;

	const violationMessages = [...new Set(getViolationsFromError(err).map(v => toSentence(translateErrorText(v.message))))];

	let textError = (
		violationMessages.join(' ')
		|| responseData?.description
		|| responseData?.['hydra:description']
		|| responseData?.message
		|| responseData?.header?.message
		|| requestError?.message
	);

	if (typeof textError === 'string' && textError === responseData?.description) {
		const batchIndexSubstring = textError.match(BATCH_INDEX_DESCRIPTION_SEARCH)?.at(0);
		index = batchIndexSubstring ? parseInt(batchIndexSubstring.replace(/[^0-9]/g, "")) : undefined;
		try {
			const detail = typeof responseData?.detail === 'string'
				? JSON.parse(responseData.detail) as { description?: string; status?: number }
				: undefined;
	
			if (detail && index !== undefined) {
				textError = detail.description || 'Erreur';
				errorCode = detail.status ? ` (code erreur ${detail.status.toString()})` : errorCode;
			}
		} catch { /* empty */ }
	}
	const textErrorTranslated = translateErrorText(textError);

	let description: string | undefined = textErrorTranslated + errorCode;

	if (description === 'undefined') {
		description = undefined;
	}

	if (index !== undefined) {
		return `Élément n°${index + 1}: ${description}`;
	}
	return description;
}
